var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.16662H16.45C16.1591 6.39568 15.7071 5.69568 15.1242 5.1133L12.2209 2.2083C11.6378 1.62607 10.9376 1.17439 10.1667 0.883301V6.3333C10.1667 6.7935 10.5398 7.16662 11 7.16662Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8133 8.83332H11C9.6193 8.83332 8.50001 7.71402 8.50001 6.33332V0.52C8.36583 0.51082 8.23169 0.5 8.09583 0.5H4.33333C2.03329 0.502773 0.169421 2.36664 0.166687 4.66668V16.3334C0.169421 18.6334 2.03329 20.4973 4.33333 20.5H12.6666C14.9667 20.4973 16.8306 18.6334 16.8333 16.3333V9.2375C16.8333 9.10168 16.8225 8.9675 16.8133 8.83332Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.601918fafc2d5de8208afaa243336b43.svg";
export { ForwardRef as ReactComponent };